<template>
  <div>
    <div class="quicknav">
      <div
        class="qnlist"
        v-for="(nav, index) in navs"
        :key="index"
        :class="{ qnactive: nav.isactive }"
        @mouseover="nav.isactive = true"
        @mouseleave="nav.isactive = currentnav == index"
        @click="scrollto(nav.navid)"
      >
        {{ nav.isactive ? nav.name : '' }}
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img src="/static/img/sk/p1.jpg" width="100%" alt="Blueshark R1" />
      </div>
      <div class="text t1">
        <div
          class="fs_big fw_bold color_theme t1_1 aniel"
          :class="{ ani: ani.a1 }"
        >
          Blueshark R1
        </div>
        <div class="fs_big fw_bold t1_2 aniel" :class="{ ani1: ani.a1 }">
          Smart Electric Motorcycle
        </div>
        <div class="aniel" :class="{ ani2: ani.a1 }">
          내연기관을 넘어 새로움과 혁신을 담다.
        </div>
      </div>
      <div class="text t1a" id="a2">
        <div>
          <span :class="{ aniel: true, ani: ani.a2 }">
            <span class="fs_middle">110</span> km
          </span>
          <br />
          <span class="fs_tiny color_gray aniel" :class="{ ani1: ani.a2 }">
            주행거리
          </span>
        </div>
        <div>
          <span :class="{ aniel: true, ani: ani.a2 }">
            <span class="fs_middle">80</span> km/h
          </span>
          <br />
          <span class="fs_tiny color_gray aniel" :class="{ ani1: ani.a2 }">
            안전최고속도
          </span>
        </div>
        <div>
          <span :class="{ aniel: true, ani: ani.a2 }">
            <span class="fs_normal fw_bold">Dual ECUs + CAN Bus</span>
          </span>
          <br />
          <span class="fs_tiny color_gray aniel" :class="{ ani1: ani.a2 }">
            스마트 중앙제어 시스템
          </span>
        </div>
        <div>
          <span :class="{ aniel: true, ani: ani.a2 }">
            <span class="fs_normal fw_bold">ArkRide</span>
            <span class="fs_normal">OS 2.0</span>
          </span>
          <br />
          <span class="fs_tiny color_gray aniel" :class="{ ani1: ani.a2 }">
            스마트 운영체제
          </span>
        </div>
      </div>
    </div>
    <!-- <div class="page" id="n1">
      <div class="pic">
        <img
          src="/static/img/sk/p2.jpg"
          width="100%"
          alt="Blueshark R1 Smart Electric Motocycle"
        />
      </div>
      <div class="text t2" id="a3">
        <div class="title fs_big fw_bold aniel" :class="{ ani: ani.a3 }">
          blueshark R1
        </div>
        <div class="fs_content content aniel" :class="{ ani1: ani.a3 }">
          자동차 기술로 탄생한 스마트 전기 모터사이클
        </div>
      </div>
    </div> -->
    <div class="page" id="n1">
      <swiper3 ref="swiper3"></swiper3>
    </div>
    <div class="page" id="s4">
      <swiper4></swiper4>
      <div class="text t4" id="a4">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a4 }">
          Double Hydraulic Disc Brakes with CBS
        </div>
        <div class="fs_sub color_gray t4_1 aniel" :class="{ ani1: ani.a4 }">
          라이더의 안전을 위해
        </div>
        <div class="fs_tiny content t4_2 aniel" :class="{ ani2: ani.a4 }">
          Blueshark R1 에는 이중 유압 디스크 브레이크가 장착되어 있는 연동
          시스템으로 이루어져 어떤 브레이크 레버를 당겨도 두 바퀴를 동시에
          제동력을 전달 할 수 있습니다.
        </div>
      </div>
    </div>
    <div class="page" id="n2">
      <div class="pic">
        <img
          src="/static/img/sk/p5.jpg"
          width="100%"
          alt="Blueshark R1 electric motor controller"
        />
      </div>
      <div class="text t5" id="a5">
        <div class="fs_big1 fw_bold t5_1 aniel" :class="{ ani: ani.a5 }">
          Steer at Will
        </div>
        <div class="fs_sub color_gray t5_2 aniel" :class="{ ani1: ani.a5 }">
          부드럽고 정밀한 제어
        </div>
        <div class="fs_tiny content1 aniel" :class="{ ani2: ani.a5 }">
          Blueshark R1 은 고출력 FOC 알고리즘의 (Field Oriented Control) 모터
          컨트롤러를 사용하여 부드럽고 유연한 라이딩을 돕습니다. 소비전력, 경량
          및 견고한 방열 구조는 자동차 규격의 품질과 기능을 갖추고 있습니다.
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img
          src="/static/img/p6.jpg"
          width="100%"
          alt="Blueshark 6 Driving Modes"
        />
      </div>
      <div class="text t6" id="a6">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a6 }">
          5 Driving Modes
        </div>
        <div class="fs_sub color_gray t6_1 aniel" :class="{ ani1: ani.a6 }">
          스마트 드라이빙 모드
        </div>
        <div class="fs_tiny content aniel" :class="{ ani2: ani.a6 }">
          Blueshark R1은 5가지의 운행 모드를 제공 합니다. 3가지의 일반
          주행모드<br />에코 주행모드, 그리고, 터보부스터 모드로 즐거운 라이딩을
          선사합니다
        </div>
      </div>
      <div class="text t6a" id="a32">
        <div class="fs_tiny color_gray aniel" :class="{ ani: ani.a32 }">
          2 개의 배터리가 동시에 사용되어야 함
        </div>
      </div>
    </div>
    <div class="page" id="n3">
      <div class="pic">
        <img
          src="/static/img/sk/p7.jpg"
          width="100%"
          alt="Blueshark dual lithium battery packs"
        />
      </div>
      <div class="text t7" id="a7">
        <div class="t7_left">
          <div class="fs_big1 fw_bold t7_1 aniel" :class="{ ani: ani.a7 }">
            Juice All Week
          </div>
          <div class="fs_sub color_gray t7_2 aniel" :class="{ ani1: ani.a7 }">
            듀얼 배터리로 운행 걱정 끝
          </div>
          <div class="fs_tiny content1 aniel" :class="{ ani2: ani.a7 }">
            Blueshark R1는 자동차급 듀얼 배터리가 탑재되어 있습니다. NEDC
            주행거리는 110km로, 이제 일주일 출퇴근 걱정 없습니다.
          </div>
        </div>
        <div class="t7_right">
          <div class="t7_3 aniel" :class="{ ani: ani.a7 }">
            <span class="fs_middle">2,880</span> Wh<br /><span
              class="fs_tiny color_gray"
              >듀얼 배터리 용량</span
            >
          </div>
          <div class="t7_3 aniel" :class="{ ani1: ani.a7 }">
            <span class="fs_middle">110</span> km<br />
            <span class="fs_tiny color_gray">
              NEDC 주행 가능 거리
            </span>
          </div>
          <div class="aniel" :class="{ ani2: ani.a7 }">
            &lt; <span class="fs_middle">3.5</span> h<br />
            <span class="fs_tiny color_gray">완충까지 3.5 시간 이내</span>
          </div>
        </div>
      </div>
      <div id="a8" class="text t7a">
        <!-- <div class="fs_tiny aniel" :class="{ani: ani.a8}">*With a 75 kg passenger, 25 degrees Celcius and a driving speed of 30 km/h</div> -->
      </div>
    </div>
    <div class="page">
      <div class="t8">
        <div
          id="a9"
          class="title fs_middle fw_bold aniel"
          :class="{ ani: ani.a9 }"
        >
          Battery Management System
        </div>
        <div class="t8a">
          <div class="t8a_item">
            <div id="a10" class="t8a_1 fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a10 }"
                ><img src="/static/img/sk/p8-11.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a10 }"
                >사전 방전</span
              >
            </div>
            <div id="a11" class="t8a_1 fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a11 }"
                ><img src="/static/img/sk/p8-21.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a11 }"
                >강/약 전기 절연</span
              >
            </div>
            <div id="a12" class="fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a12 }"
                ><img src="/static/img/sk/p8-31.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a12 }"
                >과 충전 방지</span
              >
            </div>
          </div>
          <div class="t8a_item">
            <div class="t8a_1 fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a10 }"
                ><img src="/static/img/sk/p8-12.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a10 }"
                >전압 밸런스</span
              >
            </div>
            <div class="t8a_1 fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a11 }"
                ><img src="/static/img/sk/p8-22.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a11 }"
                >방수</span
              >
            </div>
            <div class="fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a12 }"
                ><img src="/static/img/sk/p8-32.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a12 }"
                >과 방전 보호</span
              >
            </div>
          </div>
          <div class="t8a_item">
            <div class="t8a_1 fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a10 }"
                ><img src="/static/img/sk/p8-13.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a10 }"
                >충전 주기 수</span
              >
            </div>
            <div class="t8a_1 fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a11 }"
                ><img src="/static/img/sk/p8-23.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a11 }"
                >개방 회로 보호</span
              >
            </div>
            <div class="fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a12 }"
                ><img src="/static/img/sk/p8-33.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a12 }"
                >광통신</span
              >
            </div>
          </div>
          <div class="t8a_item">
            <div class="t8a_1 fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a10 }"
                ><img src="/static/img/sk/p8-14.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a10 }"
                >듀얼 배터리 방전 관리</span
              >
            </div>
            <div class="t8a_1 fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a11 }"
                ><img src="/static/img/sk/p8-24.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a11 }"
                >단락 보호</span
              >
            </div>
            <div class="fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a12 }"
                ><img src="/static/img/sk/p8-34.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a12 }"
                >배터리 고장의 2 차 보호</span
              >
            </div>
          </div>
          <div class="t8a_item">
            <div class="t8a_1 fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a10 }"
                ><img src="/static/img/sk/p8-15.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a10 }"
                >듀얼 배터리 충전 관리</span
              >
            </div>
            <div class="t8a_1 fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a11 }"
                ><img src="/static/img/sk/p8-25.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a11 }"
                >과전류 보호</span
              >
            </div>
            <div class="fs_tiny color_gray">
              <span class="aniel" :class="{ ani: ani.a12 }"
                ><img src="/static/img/sk/p8-35.png" alt=""/></span
              ><br /><span class="aniel fs_tiny" :class="{ ani1: ani.a12 }"
                >과열 보호</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img
          src="/static/img/sk/p9.jpg"
          width="100%"
          alt="Blueshark turbo boost mode"
        />
      </div>
      <div class="text normalt" id="a13">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a13 }">
          Turbo Boost Mode
        </div>
        <div class="fs_sub color_gray mb10 aniel" :class="{ ani1: ani.a13 }">
          더 길게 더 빠르게
        </div>
        <div class="fs_tiny aniel" :class="{ ani2: ani.a13 }">
          직렬과 병렬 연결을 자동으로 전환하여 더 긴 주행거리와 더 뛰어난 파워를
          전달합니다
        </div>
      </div>
      <div class="text t9a" id="a31">
        <div class="fs_tiny color_gray aniel" :class="{ ani: ani.a31 }">
          *2 개의 배터리가 동시에 사용되어야 함.
        </div>
      </div>
    </div>
    <div class="page">
      <swiper10></swiper10>
      <div class="text normalt" id="a14">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a14 }">
          Multi-Scenario Flash Charge
        </div>
        <div class="fs_sub color_gray mb10 aniel" :class="{ ani1: ani.a14 }">
          전기만 있다면 어디든 충전소
        </div>
        <div class="fs_tiny content aniel" :class="{ ani2: ani.a14 }">
          220v로 어디서나 쉽고 편리하게 충전이 가능하며<br />80% 충전에 2시간
          30분 100% 완충 3시간이면 충분합니다
        </div>
      </div>
    </div>
    <div class="page" id="n4">
      <swiper11></swiper11>
      <div class="text t11" id="a15">
        <div class="title fs_big1 fw_bold aniel" :class="{ ani: ani.a15 }">
          Designed with Disciplined<br />Passion
        </div>
      </div>
    </div>
    <div class="page">
      <div class="lisablack" id="a16"></div>
    </div>
    <!-- <div class="page" id="n6">
      <div class="pic"><img src="/static/img/p12.jpg" width="100%" alt=""></div>
      <div class="text normalt" id="a16">
        <div class="title fs_big1 fw_bold aniel" :class="{ani: ani.a16}">Craftsmanship Trumps Everything</div>
      </div>
      <div class="text t12">
        <div class="fs_tiny">Manufactured in the Same Factory as Benelli</div>
        <div class="fs_tiny t12_2">Top Class Supply Chain Partners</div>
        <div class="fs_tiny">200 kg Carrying Capacity</div>
      </div>
    </div> -->
    <div class="page" id="n5">
      <div class="pic">
        <img
          src="/static/img/sk/p13.jpg"
          width="100%"
          alt="Blueshark automotive technology"
        />
      </div>
      <div class="text normalt" id="a17">
        <div class="title fs_big1 fw_bold aniel" :class="{ ani: ani.a17 }">
          Automotive Technology
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img
          src="/static/img/sk/p14.jpg"
          width="100%"
          alt="Blueshark dual ECUs + CAN bus"
        />
      </div>
      <div class="text normalt" id="a18">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a18 }">
          Power & System Domain Controllers
        </div>
        <div class="fs_tiny content aniel" :class="{ ani1: ani.a18 }">
          시스템 도메인 컨트롤러는 2G/4G 통신 모듈을 통해 Blueshark의 IoV
          시스템에 연결되며, 다른 하나는 운전 상태를 실시간으로 모니터하고
          조절합니다.<br />
          두 도메인 컨트롤러는 독립적으로 작동하거나 CAN 버스를 통해 하나로
          연결할 수 있습니다.
        </div>
      </div>
    </div>
    <div class="page">
      <swiper15></swiper15>
      <div class="text normalt" id="a19">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a19 }">
          10" Full-Color HD IPS Panel Display
        </div>
        <div class="fs_sub color_gray mb10 aniel" :class="{ ani1: ani.a19 }">
          더 선명하게 더 정확하게
        </div>
        <div class="fs_tiny content aniel" :class="{ ani2: ani.a19 }">
          Blueshark R1 은 ArkRide OS 가 탑재 된 풀 HD급의 칼라 IPS스크린이
          장착되며<br />4G 네비게이션, 음악/비디오, 블랙박스 기능, OTA (온 더
          에어) 업데이트등 차원이 다른 멀티 미디어 시스템을 구현 합니다
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img
          src="/static/img/p16.jpg"
          width="100%"
          alt="Blueshark R1 AI range estimation"
        />
      </div>
      <div class="text normalt" id="a20">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a20 }">
          AI Range Estimation
        </div>
        <div class="fs_sub color_gray mb10 aniel" :class="{ ani1: ani.a20 }">
          인공지능 운행거리 계산시스템
        </div>
        <div class="fs_tiny content aniel" :class="{ ani2: ani.a20 }">
          Blueshark R1은 주변 온도 탑승 중량 등의 현재 컨디션을 반영한<br />최대
          운행가능 거리를 인공지능으로 계산하여 라이더에게 통보합니다
        </div>
      </div>
    </div>
    <div class="page">
      <div class="lisablack" id="a21">
        <!-- <div class="title fs_middle fw_bold aniel" :class="{ani: ani.a21}">“Hello, Lisa.”</div>
        <div class="fs_tiny content aniel" :class="{ani1: ani.a21}">Say hello to your AI driving companion Lisa. Your ride will never be lonely with her company.</div> -->
      </div>
      <div class="pic">
        <!-- <video src="/static/img/lisa.mp4" width="100%" autoplay="autoplay" loop="loop" muted="muted"></video> -->
      </div>
    </div>
    <!-- <div class="page">
      <div class="lisablack" id="a21">
        <div class="title fs_middle fw_bold aniel" :class="{ani: ani.a21}">“Hello, Lisa.”</div>
        <div class="fs_tiny content aniel" :class="{ani1: ani.a21}">Say hello to your AI driving companion Lisa. Your ride will never be lonely with her company.</div>
      </div>
      <div class="pic">
        <video src="/static/img/lisa.mp4" width="100%" autoplay="autoplay" loop="loop" muted="muted"></video>
      </div>
    </div> -->
    <div class="page">
      <div class="pic">
        <img src="/static/img/sk/p17.jpg" width="100%" alt="Blueshark APP" />
      </div>
      <div class="text normalt" id="a22">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a22 }">
          Blueshark APP
        </div>
        <div class="fs_sub color_gray mb10 aniel" :class="{ ani1: ani.a22 }">
          더 스마트한 바이크 관리
        </div>
        <div class="fs_tiny content aniel" :class="{ ani2: ani.a22 }">
          Blueshark R1의 다양한 정보 위치, 원격제어, 주행 통계, 배터리 상태,
          차량 이상 유무를<br />이제 스마트폰에서 편리하게 확인 가능합니다
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img
          src="/static/img/sk/p18.jpg"
          width="100%"
          alt="Blueshark R1 with 74 sensors"
        />
      </div>
      <div class="text normalt" id="a23">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a23 }">
          70+ Sensors
        </div>
        <div class="fs_sub color_gray mb10 aniel" :class="{ ani1: ani.a23 }">
          바이크에 한계를 넘어
        </div>
        <div class="fs_tiny content aniel" :class="{ ani2: ani.a23 }">
          Blueshark R1의 70여 개의 첨단 센서는 가속도, 온도, 조명, 압력 등의
          정보를 라이더에게 제공하여 안전하고 쾌적한 주행을 가능하게 합니다.
        </div>
      </div>
    </div>
    <div class="page">
      <div class="pic">
        <img
          src="/static/img/sk/p19.jpg"
          width="100%"
          alt="Blueshark R1 helping boost mode"
        />
      </div>
      <div class="text normalt" id="a24">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a24 }">
          Move Assist Mode (MAM)
        </div>
        <div class="fs_sub color_gray mb10 aniel" :class="{ ani1: ani.a24 }">
          라이더를 보호하다
        </div>
        <div class="fs_tiny content aniel" :class="{ ani2: ani.a24 }">
          Move Assist 모드를 활성화하면 핸들을 돌리거나 기어 버튼을 왼쪽으로
          움직이면 R1이 걷는 속도로 전진하도록 도와주는 힘이 가해집니다.<br />
          기어 버튼을 오른쪽으로 움직이면 R1을 천천히 후진하도록 도와주어 R1의
          이동을 더 쉽고 편리하게 만듭니다.
        </div>
      </div>
    </div>
    <div class="page">
      <swiper20></swiper20>
      <div class="text normalt" id="a25">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a25 }">
          Advanced Driver-Assistance Systems
        </div>
        <div class="fs_sub color_gray mb10 aniel" :class="{ ani1: ani.a25 }">
          탁월한 라이딩 보조시스템
        </div>
        <div class="fs_tiny content aniel" :class="{ ani2: ani.a25 }">
          ADAS(고급 운전자 보조 시스템)는 주행 과정을 기록합니다. 이미지와
          알림이 핸들바에 부착된 디스플레이에 실시간으로 표시됩니다.
        </div>
      </div>
    </div>
    <div class="page" id="n6">
      <swiper21></swiper21>
      <div class="text normalt" id="a26">
        <div class="title fs_big1 fw_bold aniel" :class="{ ani: ani.a26 }">
          Safety Matters
        </div>
        <div class="fs_sub color_gray mb10 aniel" :class="{ ani1: ani.a26 }">
          견고한 보안 시스템
        </div>
        <div class="fs_tiny content aniel" :class="{ ani2: ani.a26 }">
          스마트폰이나 블루투스 원격 제어를 통해 차량에 접근하면 자동으로 차량을
          언락하고 잠그고, 멀어질 때 차량을 보호하고 잠글 수 있습니다.<br />
          전체 작업 과정은 직관적으로 이루어지며 추가 조작이 필요하지 않습니다.
        </div>
      </div>
    </div>
    <div class="page">
      <swiper22></swiper22>
    </div>
    <div class="page">
      <swiper23></swiper23>
    </div>
    <div class="page p24">
      <div id="a27">
        <div class="title fs_middle fw_bold aniel" :class="{ ani: ani.a27 }">
          Specs & Features
        </div>
        <div class="t24p aniel" :class="{ ani1: ani.a27 }">
          <div>
            <img
              src="/static/img/p24-1-en.png"
              width="100%"
              alt="Blueshark R1 specs and features"
            />
          </div>
        </div>
        <div class="t24">
          <div class="feature" id="a28">
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a28 }">
                적정 하중
              </span>
              <br /><span class="fs_tiny aniel" :class="{ ani1: ani.a28 }">
                200 kg
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a28 }">
                무게(배터리 제외)
              </span>
              <br /><span class="fs_tiny aniel" :class="{ ani1: ani.a28 }">
                115 kg
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a28 }">
                색상
              </span>
              <br /><span class="fs_tiny aniel" :class="{ ani1: ani.a28 }">
                Spindrift White<br />Deepsea Black<br />Blueshark Blue<br />
                Pine Green<br />Coconut Brown
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a28 }">
                시동
              </span>
              <br /><span class="fs_tiny aniel" :class="{ ani1: ani.a28 }">
                지문 인식 센서
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a28 }">
                액정
              </span>
              <br /><span class="fs_tiny aniel" :class="{ ani1: ani.a28 }">
                10” 풀 칼라 HD IPS 디스플레이
              </span>
            </div>
          </div>
          <div class="feature" id="a29">
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a29 }">
                스마트 운영체제
              </span>
              <br /><span class="fs_tiny aniel" :class="{ ani1: ani.a29 }">
                ArkRide OS
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a29 }">
                배터리 용랑
              </span>
              <br /><span class="fs_tiny aniel" :class="{ ani1: ani.a29 }">
                1,440*2 Wh
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a29 }">
                주행거리
              </span>
              <br /><span class="fs_tiny aniel" :class="{ ani1: ani.a29 }">
                110 km
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a29 }">
                최고 출력
              </span>
              <br /><span class="fs_tiny aniel" :class="{ ani1: ani.a29 }">
                5,000 W
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a29 }">
                안전최고속도
              </span>
              <br /><span class="fs_tiny aniel" :class="{ ani1: ani.a29 }">
                80 km/h
              </span>
            </div>
          </div>
          <div class="feature" id="a30">
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a30 }">
                최고 회전 수
              </span>
              <br /><span class="fs_tiny aniel" :class="{ ani1: ani.a30 }">
                5,500 rpm
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a30 }">
                스마트 중앙제어 시스템
              </span>
              <br /><span class="fs_tiny aniel" :class="{ ani1: ani.a30 }">
                전방 카메라는 선택 사양입니다
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a30 }">
                주행보조 시스템
              </span>
              <br /><span class="fs_tiny aniel" :class="{ ani1: ani.a30 }">
                듀얼 카메라 + 듀얼 초음파 센서
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a30 }">
                브레이크 시스템
              </span>
              <br /><span class="fs_tiny aniel" :class="{ ani1: ani.a30 }">
                CBS 이중 유압 DISC 브레이크<br />Combined Brake System
              </span>
            </div>
            <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ ani: ani.a30 }">
              </span>
              <br />
              <span class="fs_tiny aniel" :class="{ ani1: ani.a30 }"></span>
            </div>
            <!-- <div class="featureitem fs_tiny">
              <span class="fs_tiny color_gray aniel" :class="{ani: ani.a30}">Voice Assistant</span><br/><span class="fs_tiny aniel" :class="{ani1: ani.a30}">Smart Driving<br/>Companion "Lisa"</span></div> -->
          </div>
          <!-- <div class="csenv" id="a35">
            *Theoretical range with a 70 kg passenger, 25 ℃ and a driving speed
            of 25 km/h
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swiper3 from '../swiper_sk/swiper3'
import swiper4 from '../swiper_sk/swiper4'
import swiper10 from '../swiper_sk/swiper10'
import swiper11 from '../swiper_sk/swiper11'
import swiper15 from '../swiper_en/swiper15' // 这里与英文内容同步
import swiper20 from '../swiper_sk/swiper20'
import swiper21 from '../swiper_sk/swiper21' // 这里与英文内容同步
import swiper22 from '../swiper_sk/swiper22'
import swiper23 from '../swiper_sk/swiper23'
import { throttle } from 'lodash'
export default {
  data() {
    return {
      ani: {
        a1: false,
        a2: false,
        a3: false,
        a4: false,
        a5: false,
        a6: false,
        a7: false,
        a8: false,
        a9: false,
        a10: false,
        a11: false,
        a12: false,
        a13: false,
        a14: false,
        a15: false,
        a16: false,
        a17: false,
        a18: false,
        a19: false,
        a20: false,
        a21: false,
        a22: false,
        a23: false,
        a24: false,
        a25: false,
        a26: false,
        a27: false,
        a28: false,
        a29: false,
        a30: false,
        a31: false,
        a32: false
      },
      navs: [
        // { name: 'R1', isactive: false, navid: 'n1' },
        { name: '성능', isactive: false, navid: 'n1' },
        { name: '조향/조작', isactive: false, navid: 'n2' },
        { name: '주행가능 거리', isactive: false, navid: 'n3' },
        { name: '디자인', isactive: false, navid: 'n4' },
        { name: '스마트', isactive: false, navid: 'n5' },
        { name: '안전', isactive: false, navid: 'n6' }
      ],
      currentnav: -1
      // aniarr: ["a1","a2","a3"]
    }
  },
  components: {
    swiper3,
    swiper4,
    swiper10,
    swiper11,
    swiper15,
    swiper20,
    swiper21,
    swiper22,
    swiper23
  },
  mounted() {
    window.scrollTo(0, 0)
    this.$nextTick(() => {
      window.addEventListener(
        'scroll',
        throttle(this.animateTxt, 500, { leading: true })
      )
    })
    setTimeout(() => {
      this.ani.a1 = true
    }, 300)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.animateTxt)
  },
  methods: {
    getscrolltop(id) {
      let obj = document.getElementById(id)
      if (obj) {
        let top = obj.offsetTop
        while ((obj = obj.offsetParent)) {
          top += obj.offsetTop
        }
        return top
      }
    },
    scrollto(id) {
      window.scrollTo(0, this.getscrolltop(id))
    },
    setnavs() {
      for (let i in this.navs) {
        this.navs[i].isactive = false
      }
    },
    animateTxt() {
      let top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset
      // let width = document.body.clientWidth
      let height = document.body.clientHeight
      if (top <= 100) {
        this.$emit('hidenav')
      } else {
        this.$emit('shownav')
      }
      // 左侧快速导航
      for (let i = 1; i < 7; i++) {
        let prev = i > 0 ? this.getscrolltop('n' + i) : 0
        let next = i < 6 ? this.getscrolltop('n' + (i + 1)) : 1000000
        if (top >= prev && top < next) {
          this.setnavs()
          if (i > 0) {
            this.navs[i - 1].isactive = true
          }
          this.currentnav = i - 1 // 锁定当前页
          break
        }
      }
      // 每一页文字出现特效
      for (let i = 4; i < 33; i++) {
        if (
          top > this.getscrolltop('a' + i) - height + 200 &&
          top < this.getscrolltop('a' + i)
        ) {
          this.ani['a' + i] = true
        }
      }
      if (
        top > this.getscrolltop('n1') - height + 200 &&
        top < this.getscrolltop('n1')
      ) {
        if (this.$refs.swiper3) {
          this.$refs.swiper3.startani1()
        }
      }
      if (
        top > this.getscrolltop('s4') - height &&
        top < this.getscrolltop('s4') - 300
      ) {
        if (this.$refs.swiper3) {
          this.$refs.swiper3.startani2()
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/common.less';
.subscript {
  font-size: 10px;
  vertical-align: top;
}
.quicknav {
  position: fixed;
  left: 0;
  top: 30vh;
  color: #fff;
  z-index: 100;
  .qnlist {
    padding-left: 40px;
    position: relative;
    cursor: pointer;
    width: 150px;
    height: 30px;
  }
  .qnlist::before {
    position: absolute;
    content: '';
    width: 15px;
    height: 0;
    border-top: 1px solid #666;
    top: 10px;
    left: 15px;
  }
  .qnactive::before {
    position: absolute;
    content: '';
    width: 30px;
    height: 0;
    border-top: 1px solid #fff;
    top: 10px;
    left: 0;
  }
}
.page {
  position: relative;
  background-color: #000;
  .pic {
    font-size: 0;
  }
  .lisablack {
    background-color: #000;
    // height: 8vw;
    color: #fff;
    text-align: center;
    // padding-top: 4vw;
  }
  .title {
    margin-bottom: 26px;
  }
  .content {
    line-height: 24px;
  }
  .content1 {
    line-height: 20px;
  }
  .text {
    position: absolute;
    z-index: 1;
    color: #fff;
  }
  .mb10 {
    margin-bottom: 10px;
  }
  .t1 {
    text-align: center;
    left: 0;
    top: 0;
    margin: 160px auto;
    right: 0;
    .t1_1 {
      margin-bottom: 5px;
    }
    .t1_2 {
      margin-bottom: 15px;
    }
  }
  .t1a {
    display: flex;
    display: -webkit-flex;
    justify-content: space-around;
    bottom: 80px;
    margin: 0 auto;
    left: 0;
    right: 0;
    text-align: center;
    width: 70%;
  }
  .t2 {
    left: 18vw;
    top: 9vw;
  }
  .t4 {
    left: 12vw;
    top: 15vw;
    width: 400px;
    .t4_1 {
      margin-bottom: 10px;
    }
    .t4_2 {
      text-align: justify;
    }
  }
  .t5 {
    left: 12vw;
    top: 15vw;
    width: 400px;
    text-align: justify;
    .t5_1 {
      margin-bottom: 10px;
    }
    .t5_2 {
      margin-bottom: 20px;
    }
  }
  .t6 {
    top: 16vw;
    width: 100%;
    text-align: center;
    .t6_1 {
      margin-bottom: 15px;
    }
  }
  .t6a {
    width: 100%;
    text-align: center;
    bottom: 2vw;
  }
  .normalt {
    top: 4vw;
    width: 100%;
    text-align: center;
  }
  .t7 {
    left: 7vw;
    top: 11vw;
    right: 17vw;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    .t7_left {
      width: 300px;
      // text-align: justify;
      padding-top: 2vw;
    }
    .t7_1 {
      margin-bottom: 10px;
    }
    .t7_2 {
      margin-bottom: 20px;
    }
    .t7_3 {
      margin-bottom: 40px;
    }
  }
  .t7a {
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom: 3vw;
    font-size: 10px;
    text-align: center;
    color: @colorgray;
  }
  .t8 {
    background-color: #000;
    color: #fff;
    text-align: center;
    padding: 4vw 0;
    .t8a {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      width: 60%;
      margin: 80px auto 0;
      .t8a_item {
        flex: 1;
        img {
          width: 50px;
          margin-bottom: 10px;
        }
        .t8a_1 {
          margin-bottom: 50px;
          height: 90px;
        }
      }
    }
  }
  .t9a {
    width: 100%;
    text-align: center;
    bottom: 5vw;
  }
  .t11 {
    left: 7vw;
    top: 10vw;
  }
  .t12 {
    display: flex;
    display: -webkit-flex;
    left: 20vw;
    right: 23vw;
    justify-content: space-between;
    bottom: 7.5vw;
    .t12_2 {
      margin-right: 3vw;
    }
  }
  .t24p {
    padding: 2vw 18vw;
  }
  .t24 {
    margin-top: 3vw;
    .feature {
      width: 80%;
      margin: 0 auto;
      border-top: 1px solid #333;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      padding: 2vw 0 2vw 6vw;
      box-sizing: border-box;
      .featureitem {
        flex: 1;
        text-align: left;
        line-height: 24px;
        .subscript {
          display: inline-block;
          position: relative;
          top: -2px;
          transform: scale(0.8);
        }
        .fs_tiny {
          margin-bottom: 20px;
        }
      }
    }
    .csenv {
      text-align: center;
      font-size: 14px;
      color: #999;
    }
  }
}
.p24 {
  background: url(/static/img/sk/p24.jpg) no-repeat;
  background-size: cover;
  color: #fff;
  padding-bottom: 2vw;
  .title {
    padding-top: 4vw;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sk/product.vue